import { isBefore } from 'date-fns'
import { SituacaoAgendadoEnum } from 'graphql/types.generated'

import { situacoesExibirAgendamentosCidadao } from './model-cidadao'

export const getSituacoesAgendado = (today: Date, endDate?: Date): SituacaoAgendadoEnum[] =>
  isBefore(endDate, today)
    ? [...situacoesExibirAgendamentosCidadao, SituacaoAgendadoEnum.EXCLUIDO]
    : situacoesExibirAgendamentosCidadao
